import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

const SubCategoryViewAll = ({
  updateSubcategories,
  subcategory,
  subcategoryIndex,
  imageBasePath
}) => (
  <React.Fragment>
    <FormGroup className="flex-100">
      <Label>Button text</Label>
      <Input
        id="buttonText"
        type="text"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.buttonText || ''}
      />
    </FormGroup>
    <FormGroup>
      <Label>
        Tile image <small className="text-lighter">{imageBasePath}</small>
      </Label>
      <Input
        id="image"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.image || ''}
      />
    </FormGroup>
  </React.Fragment>
);

export default SubCategoryViewAll;



// WEBPACK FOOTER //
// ./src/components/categories/Subcategories/SubCategoryViewAll.js